import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/thisissupport.webp';
import screenshot_target from '../../../images/letterfunnel/wesleyvanderlinden.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Wesley van der Linden"
      firstname="Wesley"
      companyname="This is Support"
      competition="Q42 en Xebia"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/wesleyvanderlinden.js